module.exports = __webpack_public_path__ + "img/1390439504.527b8c55.jpg";